import { ROOM_CODE_ALPHABET, ROOM_CODE_LENGTH } from '@runkr/schema'

const SHARE_PATH = /^\/r\/([^/]*)\/?$/

/**
 * The code in a share link's path `/r/<CODE>` (PHASE2 T2.7, D-040), upper-cased. `undefined`
 * when the path is not a share link at all; `null` when it is one with a bad code (wrong length
 * or a character outside the §5.2 alphabet), which the menu shows as an unknown code.
 */
export function shareLinkCode(pathname: string): string | null | undefined {
  const m = SHARE_PATH.exec(pathname)
  if (!m) return undefined
  let raw = m[1] ?? ''
  try {
    raw = decodeURIComponent(raw)
  } catch {
    return null
  }
  const code = raw.toUpperCase()
  if (code.length !== ROOM_CODE_LENGTH) return null
  for (const ch of code) if (!ROOM_CODE_ALPHABET.includes(ch)) return null
  return code
}

/** `<origin>/r/<CODE>`: opens the party or private race lobby with that code. */
export function shareLink(origin: string, code: string): string {
  return `${origin.replace(/\/$/, '')}/r/${code}`
}
